
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61034_19270)"}},[_c('circle',{attrs:{"cx":"16.248","cy":"8.781","r":"7.434","transform":"rotate(45 16.248 8.781)","fill":"#fff","fill-opacity":".3"}}),_c('path',{attrs:{"d":"M9 14a1 1 0 100-2 1 1 0 000 2z","fill":"#FDFDFD"}}),_c('path',{attrs:{"d":"M9 10.5v-.571c1.105 0 2-.768 2-1.715 0-.946-.895-1.714-2-1.714s-2 .768-2 1.714m8.37-.704a6.75 6.75 0 015.583 9.928l.765 2.602a.75.75 0 01-.93.931l-2.6-.768A6.755 6.755 0 018.63 16.49m-5.584-3.552a6.75 6.75 0 112.766 2.765l-2.603.765a.75.75 0 01-.93-.93l.767-2.6z","stroke":"#FDFDFD","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61034_19270"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    